// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-background {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.065);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-card {
  margin: 20px 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.12);
}
ion-card:first-child {
  margin: 10px 10px 20px;
}
ion-card .wrapper {
  width: 100%;
}
ion-card .new-event-icon {
  position: absolute;
  color: orange;
  top: 5px;
  font-size: 13px;
  right: 5px;
  z-index: 3;
}
ion-card ion-item-options .myBookings-sliding-options {
  margin: 1px;
  color: black;
  border-radius: 10px;
  font-size: 12px;
  padding: 0 7px;
}
ion-card ion-item-options .myBookings-sliding-options ion-icon {
  font-size: 24px;
}
ion-card .booking-card-item {
  --inner-padding-end: 0;
  --padding-start: 0;
}
ion-card .booking-card-wrapper {
  width: 100%;
  min-width: 0;
  padding: 0;
}
ion-card .booking-main-layout {
  display: flex;
  flex-direction: column;
}
ion-card .booking-main-top {
  display: flex;
  align-items: stretch;
  gap: 8px;
  padding: 10px;
  min-width: 0;
}
ion-card .booking-time-column {
  min-width: 45px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  line-height: 1.35;
  gap: 3px;
  color: #5f6368;
  white-space: nowrap;
}
ion-card .booking-time-column .start-time {
  font-size: 12px;
  font-weight: 700;
  color: #3f444a;
}
ion-card .booking-time-column .end-time {
  font-size: 11px;
  font-weight: 500;
  color: #72777d;
}
ion-card .booking-time-divider {
  width: 1px;
  background: #d6d6d6;
  align-self: stretch;
}
ion-card .booking-right-column {
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}
ion-card .booking-rows {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
ion-card .booking-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
ion-card .booking-subject {
  min-width: 0;
  font-size: 14px;
  font-weight: 700;
  color: #1f1f1f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
ion-card .booking-subject.cancelled .prefix {
  color: #666;
  margin-right: 3px;
}
ion-card .booking-subject.cancelled .body {
  color: #666;
  text-decoration: line-through;
}
ion-card .series-icon {
  font-size: 15px;
  color: #4e4e4e;
  flex-shrink: 0;
}
ion-card .teams-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  flex-shrink: 0;
}
ion-card .expired-chip,
ion-card .running-chip {
  flex-shrink: 0;
  min-height: unset;
  margin: 0;
  border-radius: 4px;
  padding: 0 6px;
}
ion-card .expired-chip ion-label,
ion-card .running-chip ion-label {
  font-size: 10px;
  font-weight: 600;
  margin: 0;
  overflow: visible;
  text-overflow: clip;
  white-space: nowrap;
}
@media (max-width: 369px) {
  ion-card .expired-chip,
  ion-card .running-chip {
    padding: 0 4px;
  }
  ion-card .expired-chip ion-label,
  ion-card .running-chip ion-label {
    font-size: calc(7px + 0.8vw);
  }
}
ion-card .booking-location-row {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}
ion-card .booking-location-row .icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
ion-card .booking-location-row .location-pin {
  color: #ed143d;
  font-size: 12px;
  flex-shrink: 0;
}
ion-card .booking-location-row .location-name {
  color: #666;
  font-size: 10px;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
ion-card .booking-meta-row {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  min-width: 0;
}
ion-card .booking-meta-row .booking-invited-by-inline {
  display: flex;
  align-items: center;
  min-width: 0;
  max-width: 100%;
}
ion-card .booking-meta-row .booking-invited-by-inline .invited-by-line {
  color: #666;
  font-size: 10px;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
ion-card .booking-meta-row ion-chip {
  margin: 0;
  min-height: 20px;
  border-radius: 12px;
  padding: 0 6px;
  font-size: 10px;
}
ion-card .booking-meta-row ion-chip ion-label {
  margin: 0;
}
ion-card .booking-meta-row ion-chip ion-icon {
  font-size: 12px;
  margin-right: 3px;
}
ion-card .attendees-stack {
  display: flex;
  align-items: center;
  margin-left: 3px;
}
ion-card .attendee-avatar {
  border-radius: 50%;
  margin-left: -2px;
  box-shadow: 0 1px 3px rgba(28, 36, 46, 0.22);
  --size:20px;
}
ion-card .attendee-avatar.no-image {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid #787878;
  background: linear-gradient(145deg, #f7f8fa 0%, #e9edf2 100%);
  color: #38424f;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.1px;
}
ion-card .attendee-avatar:first-child {
  margin-left: 0;
}
ion-card .attendee-avatar.organizer {
  background: linear-gradient(145deg, #dde2ea 0%, #c9d3e0 100%);
  color: #1f2e41;
  box-shadow: 0 1px 4px rgba(22, 31, 44, 0.26);
  width: 24px;
  height: 24px;
  --size:24px;
}
ion-card .attendee-avatar.overflow {
  background: linear-gradient(145deg, #f2f4f7 0%, #e2e7ee 100%);
  color: #556273;
  font-weight: 700;
  width: 16px;
  height: 16px;
}
ion-card .booking-card-actions {
  display: flex;
  align-items: center;
  align-self: center;
  gap: 6px;
  margin-left: 4px;
  color: #5f6368;
  font-size: 20px;
}
ion-card .booking-card-actions .delete-icon {
  color: #ed143d;
}
ion-card .booking-card-actions .chevron-icon {
  font-size: 22px;
  color: #737373;
}
ion-card .booking-bottom-divider {
  margin: 0 auto;
  width: calc(100% - 20px);
  height: 1px;
  background: #e2e2e2;
}
ion-card .booking-bottom-row {
  display: flex;
  align-items: end;
  justify-content: end;
  min-height: 45px;
  padding-left: 10px;
}
ion-card .booking-bottom-row .booking-timer {
  flex: 1;
  min-width: 0;
  margin-right: 10px;
  margin-bottom: 5px;
}
ion-card .booking-bottom-row .booking-timer.booking-time-until-start {
  align-self: center;
}
ion-card .booking-bottom-row .booking-timer.booking-time-until-start .timer-label {
  font-size: 10px;
  font-weight: 600;
  color: #757575;
  text-align: start;
}
ion-card .booking-bottom-row .booking-timer.booking-time-until-start .timer-label.urgent {
  color: #ed143d;
}
ion-card .booking-bottom-row .booking-bottom-button {
  width: 100px;
  height: 38px;
  margin: 0;
  text-transform: none;
}
ion-card .booking-bottom-row .booking-bottom-button.check-out-button {
  --background: #ed143d;
  --background-hover: #d91237;
  --background-activated: #c01031;
  --background-focused: #d91237;
  --ripple-color: rgba(255, 255, 255, 0.35);
  text-transform: none;
}
ion-card .booking-bottom-row .booking-bottom-button.with-extend-meeting {
  height: 30px;
  margin-right: -10px;
  margin-bottom: 1px;
}
ion-card .booking-bottom-row .booking-bottom-button.extend-button {
  --background: #fefefe;
  --background-hover: #f6f6f6;
  --background-activated: #efefef;
  --background-focused: #f6f6f6;
  --ripple-color: rgba(0, 0, 0, 0.12);
}
ion-card .booking-bottom-row .booking-bottom-button.extend-button .content {
  color: #787878;
}
ion-card .booking-bottom-row .booking-bottom-button.extend-button::part(native) {
  box-shadow: -2px 2px 20px 0px rgba(0, 0, 0, 0.1490196078);
}
ion-card .booking-bottom-row .booking-bottom-button.loading {
  --background: #FFC409;
  --background-hover: #FFC409;
  --background-activated: #FFC409;
  --background-focused: #FFC409;
}
ion-card .booking-bottom-row .booking-bottom-button .content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
ion-card .booking-bottom-row .booking-bottom-button ion-icon {
  font-size: 20px;
}
ion-card .booking-bottom-row .booking-bottom-button .extend-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  flex-shrink: 0;
}
ion-card .booking-bottom-row .booking-bottom-button::part(native) {
  border-radius: 0;
  border-top-left-radius: 15px;
}
ion-card .booking-bottom-row ion-item::part(native) {
  --inner-padding-end: 0px;
  --padding-start: 0;
}
ion-card .booking-bottom-row ion-card-header {
  padding: 10px 10px 0 0px;
  margin-left: 10px;
}
ion-card .booking-bottom-row ion-card-header ion-card-title {
  display: flex;
  align-items: center;
  gap: 10px;
  -webkit-padding-start: 10px;
          padding-inline-start: 10px;
  justify-content: center;
}
ion-card .booking-bottom-row ion-card-header ion-card-title ion-thumbnail {
  margin-bottom: 5px;
}
ion-card .booking-bottom-row ion-card-header ion-card-title ion-thumbnail ion-avatar {
  margin: 0 auto;
}
ion-card .booking-bottom-row ion-card-header ion-card-title ion-label {
  font-size: 20px;
  flex-grow: 3;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
ion-card .booking-bottom-row ion-card-header ion-card-title .operation-buttons-container {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 26px;
  transform: translateY(-5px);
}
ion-card .booking-bottom-row ion-card-header ion-card-title .operation-buttons-container ion-icon[name=arrow-redo-outline] {
  font-size: 24px;
  color: var(--ion-color-primary);
  margin-left: 8px;
}
ion-card .booking-bottom-row ion-card-header ion-card-subtitle {
  padding-bottom: 5px;
  display: flex;
  font-size: 11px;
  align-items: center;
  margin-right: 5px;
}
ion-card .booking-bottom-row ion-card-header ion-card-subtitle .location-icon {
  margin-right: 2.5px;
}
ion-card .booking-bottom-row ion-card-content {
  margin-left: 10px;
  padding: 0px;
}
ion-card .booking-bottom-row ion-card-content .chips-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-bottom: 8px;
  padding-right: 8px;
}
ion-card .booking-bottom-row ion-card-content .event-detail {
  display: flex;
  gap: 3px;
  align-items: center;
  font-size: 13px;
  padding: 2px 5px;
}
ion-card .booking-bottom-row ion-card-content .event-detail ion-icon {
  font-size: 20px;
  margin-right: 5px;
}
ion-card .booking-bottom-row ion-card-content ion-chip {
  padding-inline: 10px;
  font-size: 11px;
}
ion-card .booking-bottom-row ion-card-content ion-chip ion-icon {
  margin-right: 3.5px;
}
ion-card .booking-bottom-row ion-card-content ion-chip.organizer-chip img {
  margin-right: 3.5px;
}

ion-popover {
  --max-height: 40vh;
  --min-width: 240px;
}

ion-popover.seriesPopOver::part(content) {
  left: 5%;
}

ion-popover.seriesPopOver {
  --width: 90%;
  --min-height: 0;
}

ion-popover.ResponsePopOver {
  --min-width: fit-content;
}

ion-popover.info-popover::part(content) {
  min-width: unset;
  width: -webkit-fit-content;
  width: fit-content;
}

ion-popover.info-popover .resource-response-tip {
  display: flex;
  align-items: center;
  gap: 8px;
}
ion-popover.info-popover .resource-response-tip ion-icon {
  font-size: 22px;
  flex-shrink: 0;
}
ion-popover.info-popover .resource-response-tip ion-label {
  margin: 0;
}

ion-popover.resource-images-popover {
  --height: unset;
  --max-height: unset;
  --width: 420px;
}
ion-popover.resource-images-popover::part(content) {
  padding: 7px;
}
ion-popover.resource-images-popover .image-swiper-container {
  --swiper-pagination-color: #ed143d;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
}
ion-popover.resource-images-popover .image-swiper-container swiper-slide .image-container {
  width: 100%;
  height: 280px;
  overflow: hidden;
}
ion-popover.resource-images-popover .image-swiper-container swiper-slide .image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
ion-popover.resource-images-popover .resource-images-info {
  padding-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
ion-popover.resource-images-popover .resource-images-info ion-label {
  font-weight: 600;
}
ion-popover.resource-images-popover .resource-images-info ion-icon {
  font-size: 16px;
  color: #ed143d;
}
ion-popover.resource-images-popover .resource-images-info ion-chip {
  cursor: default;
}

ion-popover.display-name {
  --width: 275px;
}
ion-popover.display-name ion-icon {
  font-size: 16px;
}
ion-popover.display-name ion-label {
  margin: 5px 10px;
}
ion-popover.display-name ion-label .displayName,
ion-popover.display-name ion-label .address,
ion-popover.display-name ion-label .emailAddress {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 7px 0;
  word-break: break-word;
}
ion-popover.display-name ion-label .displayName div,
ion-popover.display-name ion-label .address div,
ion-popover.display-name ion-label .emailAddress div {
  display: flex;
}
ion-popover.display-name ion-label .address {
  font-size: 12px !important;
}
ion-popover.display-name ion-label .address ion-icon {
  font-size: 16px;
}
ion-popover.display-name ion-label .displayName {
  font-size: 15px;
}
ion-popover.display-name ion-label .emailAddress ion-icon {
  color: #6e6e6e;
}
ion-popover.display-name ion-label .emailAddress small {
  color: #6e6e6e;
  font-size: 12px;
  font-weight: 500;
}

ion-popover.extend-meeting-popover {
  --width: 325px;
  --height: unset;
}
ion-popover.extend-meeting-popover .extend-meeting-container {
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
ion-popover.extend-meeting-popover .title-label {
  text-align: center;
  font-weight: 600;
}
ion-popover.extend-meeting-popover .extend-meeting-options {
  margin: 0 auto;
}
ion-popover.extend-meeting-popover .extend-meeting-options ion-chip {
  padding: 4px 8px;
  min-height: unset;
}
ion-popover.extend-meeting-popover .extend-meeting-error-note {
  text-align: center;
  font-size: 12px;
  color: #ed143d !important;
}

.container {
  font-size: 14px;
  max-height: 250px !important;
  margin: 8px 5px 8px 13px;
  overflow-y: scroll;
}
.container ion-item {
  font-size: 12px;
}
.container ion-item ion-icon {
  font-size: 30px;
  margin-right: 5px;
}
.container::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.container::-webkit-scrollbar-track {
  background: transparent;
}
.container::-webkit-scrollbar-thumb {
  background: var(--ion-color-light);
  border-radius: 2px;
}
.container .inner-scroll {
  scrollbar-width: thin;
}

.tip-container {
  margin: 8px 13px 8px 13px;
  font-size: 14px;
}

.user-response-container ion-icon {
  font-size: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/my-bookings-item/my-bookings-item.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EAIE,iBAAA;EACA,4CAAA;AAFF;AAFE;EACE,sBAAA;AAIJ;AAAE;EACE,WAAA;AAEJ;AACE;EACE,kBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;AACJ;AAGI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AADN;AAGM;EACE,eAAA;AADR;AAME;EACE,sBAAA;EACA,kBAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;EACA,UAAA;AALJ;AAQE;EACE,aAAA;EACA,sBAAA;AANJ;AAWE;EACE,aAAA;EACA,oBAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;AATJ;AAYE;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;AAVJ;AAYI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAVN;AAaI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAXN;AAeE;EACE,UAAA;EACA,mBAAA;EACA,mBAAA;AAbJ;AAgBE;EACE,YAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;AAdJ;AAiBE;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAfJ;AAkBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAhBJ;AAmBE;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjBJ;AAoBM;EACE,WAAA;EACA,iBAAA;AAlBR;AAoBM;EACE,WAAA;EACA,6BAAA;AAlBR;AAuBE;EACE,eAAA;EACA,cAAA;EACA,cAAA;AArBJ;AAwBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAtBJ;AAyBE;;EAEE,cAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;AAvBJ;AAyBI;;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AAtBN;AA0BE;EACE;;IAEE,cAAA;EAxBJ;EAyBI;;IACE,4BAAA;EAtBN;AACF;AA0BE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAxBJ;AA0BI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAxBN;AA2BI;EACE,cAAA;EACA,eAAA;EACA,cAAA;AAzBN;AA4BI;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA1BN;AA8BE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;AA5BJ;AA8BI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AA5BN;AA8BM;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA5BR;AAgCI;EACE,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA9BN;AAgCM;EACE,SAAA;AA9BR;AAiCM;EACE,eAAA;EACA,iBAAA;AA/BR;AAoCE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAlCJ;AAqCE;EACE,kBAAA;EACA,iBAAA;EACA,4CAAA;EACA,WAAA;AAnCJ;AAoCI;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6DAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AAlCN;AAoCI;EACE,cAAA;AAlCN;AAqCI;EACE,6DAAA;EACA,cAAA;EACA,4CAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAnCN;AAsCI;EACE,6DAAA;EACA,cAAA;EAEA,gBAAA;EACA,WAAA;EACA,YAAA;AArCN;AAyCE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAvCJ;AAyCI;EACE,cAAA;AAvCN;AA0CI;EACE,eAAA;EACA,cAAA;AAxCN;AA4CE;EACE,cAAA;EACA,wBAAA;EACA,WAAA;EACA,mBAAA;AA1CJ;AA6CE;EACE,aAAA;EACA,gBAAA;EACA,oBAAA;EAEA,gBAAA;EACA,kBAAA;AA5CJ;AA+CE;EACE,OAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AA7CJ;AA+CI;EACE,kBAAA;AA7CN;AA8CK;EACH,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AA5CF;AA8CE;EACE,cAAA;AA5CJ;AAmDE;EACE,YAAA;EACA,YAAA;EACA,SAAA;EACA,oBAAA;AAjDJ;AAkDI;EACI,qBAAA;EACA,2BAAA;EACA,+BAAA;EACA,6BAAA;EACA,yCAAA;EACA,oBAAA;AAhDR;AAkDI;EAEE,YAAA;EACA,mBAAA;EACA,kBAAA;AAjDN;AAmDI;EACE,qBAAA;EACA,2BAAA;EACA,+BAAA;EACA,6BAAA;EACA,mCAAA;AAjDN;AAkDM;EACE,cAAA;AAhDR;AAkDM;EACE,yDAAA;AAhDR;AAmDI;EACE,qBAAA;EACA,2BAAA;EACA,+BAAA;EACA,6BAAA;AAjDN;AAmDI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAjDN;AAoDI;EACE,eAAA;AAlDN;AAqDI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAnDN;AAsDI;EACE,gBAAA;EACA,4BAAA;AApDN;AAiEE;EACE,wBAAA;EACA,kBAAA;AA/DJ;AAoEE;EACE,wBAAA;EACA,iBAAA;AAlEJ;AAmEI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;UAAA,0BAAA;EACA,uBAAA;AAjEN;AAkEM;EACE,kBAAA;AAhER;AAiEQ;EACE,cAAA;AA/DV;AAkEM;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;AAhER;AAkEM;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,2BAAA;AAhER;AAkEM;EACE,eAAA;EACA,+BAAA;EACA,gBAAA;AAhER;AAoEI;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AAlEN;AAmEM;EACE,mBAAA;AAjER;AAsEE;EACE,iBAAA;EACA,YAAA;AApEJ;AAuEI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AArEN;AAuEI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AArEN;AAuEM;EACE,eAAA;EACA,iBAAA;AArER;AAyEI;EACE,oBAAA;EACA,eAAA;AAvEN;AAyEM;EACE,mBAAA;AAvER;AA2EQ;EACE,mBAAA;AAzEV;;AAmFA;EACE,kBAAA;EACA,kBAAA;AAhFF;;AAmFA;EACE,QAAA;AAhFF;;AAmFA;EACE,YAAA;EACA,eAAA;AAhFF;;AAmFA;EACE,wBAAA;AAhFF;;AAmFA;EACE,gBAAA;EACA,0BAAA;EAAA,kBAAA;AAhFF;;AAoFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAjFJ;AAmFI;EACE,eAAA;EACA,cAAA;AAjFN;AAoFI;EACE,SAAA;AAlFN;;AAuFA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AApFF;AAqFE;EACE,YAAA;AAnFJ;AAqFE;EACE,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAnFJ;AAqFM;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AAnFR;AAoFQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAlFV;AAuFE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AArFJ;AAsFI;EACE,gBAAA;AApFN;AAsFI;EACE,eAAA;EACA,cAAA;AApFN;AAsFI;EACE,eAAA;AApFN;;AAyFA;EACE,cAAA;AAtFF;AAuFE;EACE,eAAA;AArFJ;AAuFE;EACE,gBAAA;AArFJ;AAsFI;;;EAGE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;AApFN;AAsFM;;;EACE,aAAA;AAlFR;AAqFI;EACE,0BAAA;AAnFN;AAqFM;EACE,eAAA;AAnFR;AAsFI;EACE,eAAA;AApFN;AAuFM;EACE,cAAA;AArFR;AAuFM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AArFR;;AA2FA;EACE,cAAA;EACA,eAAA;AAxFF;AAyFE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAvFJ;AAyFE;EACE,kBAAA;EACA,gBAAA;AAvFJ;AAyFE;EACE,cAAA;AAvFJ;AAwFI;EACE,gBAAA;EACA,iBAAA;AAtFN;AAyFE;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;AAvFJ;;AA2FA;EAUE,eAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;AAjGF;AAqFE;EACE,eAAA;AAnFJ;AAqFI;EACE,eAAA;EACA,iBAAA;AAnFN;AA4FE;EACE,UAAA;EACA,WAAA;AA1FJ;AA6FE;EACE,uBAAA;AA3FJ;AA8FE;EACE,kCAAA;EACA,kBAAA;AA5FJ;AA+FE;EACE,qBAAA;AA7FJ;;AAgGA;EACE,yBAAA;EACA,eAAA;AA7FF;;AAiGE;EACE,eAAA;AA9FJ","sourcesContent":[".spinner-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.065);\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nion-card {\n  &:first-child {\n    margin: 10px 10px 20px;\n  }\n  margin: 20px 10px;\n  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.12);\n  .wrapper {\n    width: 100%;\n  }\n\n  .new-event-icon {\n    position: absolute;\n    color: orange;\n    top: 5px;\n    font-size: 13px;\n    right: 5px;\n    z-index: 3;\n  }\n  \n  ion-item-options {\n    .myBookings-sliding-options {\n      margin: 1px;\n      color: black;\n      border-radius: 10px;\n      font-size: 12px;\n      padding: 0 7px;\n\n      ion-icon {\n        font-size: 24px;\n      }\n    }\n  }\n  \n  .booking-card-item {\n    --inner-padding-end: 0;\n    --padding-start: 0;\n  }\n\n  .booking-card-wrapper {\n    width: 100%;\n    min-width: 0;\n    padding: 0 ;\n  }\n\n  .booking-main-layout {\n    display: flex;\n    flex-direction: column;\n    // gap: 8px;\n    // padding;\n  }\n\n  .booking-main-top {\n    display: flex;\n    align-items: stretch;\n    gap: 8px;\n    padding: 10px;\n    min-width: 0;\n  }\n\n  .booking-time-column {\n    min-width: 45px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    font-size: 11px;\n    line-height: 1.35;\n    gap: 3px;\n    color: #5f6368;\n    white-space: nowrap;\n\n    .start-time {\n      font-size: 12px;\n      font-weight: 700;\n      color: #3f444a;\n    }\n\n    .end-time {\n      font-size: 11px;\n      font-weight: 500;\n      color: #72777d;\n    }\n  }\n\n  .booking-time-divider {\n    width: 1px;\n    background: #d6d6d6;\n    align-self: stretch;\n  }\n\n  .booking-right-column {\n    min-width: 0;\n    flex: 1;\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 8px;\n  }\n\n  .booking-rows {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  .booking-title-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    min-width: 0;\n  }\n\n  .booking-subject {\n    min-width: 0;\n    font-size: 14px;\n    font-weight: 700;\n    color: #1f1f1f;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    &.cancelled {\n      .prefix {\n        color: #666;\n        margin-right: 3px;\n      }\n      .body {\n        color: #666;\n        text-decoration: line-through;\n      }\n    }\n  }\n\n  .series-icon {\n    font-size: 15px;\n    color: #4e4e4e;\n    flex-shrink: 0;\n  }\n\n  .teams-icon {\n    width: 16px;\n    height: 16px;\n    object-fit: contain;\n    flex-shrink: 0;\n  }\n\n  .expired-chip,\n  .running-chip {\n    flex-shrink: 0;\n    min-height: unset;\n    margin: 0;\n    border-radius: 4px;\n    padding: 0 6px;\n\n    ion-label {\n      font-size: 10px;\n      font-weight: 600;\n      margin: 0;\n      overflow: visible;\n      text-overflow: clip;\n      white-space: nowrap;\n    }\n  }\n\n  @media (max-width: 369px) {\n    .expired-chip,\n    .running-chip {\n      padding: 0 4px;\n      ion-label {\n        font-size: calc(7px + 0.8vw);\n      }\n    }\n  }\n\n  .booking-location-row {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    min-width: 0;\n\n    .icon-container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .location-pin {\n      color: #ed143d;\n      font-size: 12px;\n      flex-shrink: 0;\n    }\n\n    .location-name {\n      color: #666;\n      font-size: 10px;\n      min-width: 0;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .booking-meta-row {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    flex-wrap: wrap;\n    min-width: 0;\n\n    .booking-invited-by-inline {\n      display: flex;\n      align-items: center;\n      min-width: 0;\n      max-width: 100%;\n\n      .invited-by-line {\n        color: #666;\n        font-size: 10px;\n        min-width: 0;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n\n    ion-chip {\n      margin: 0;\n      min-height: 20px;\n      border-radius: 12px;\n      padding: 0 6px;\n      font-size: 10px;\n\n      ion-label {\n        margin: 0;\n      }\n\n      ion-icon {\n        font-size: 12px;\n        margin-right: 3px;\n      }\n    }\n  }\n\n  .attendees-stack {\n    display: flex;\n    align-items: center;\n    margin-left: 3px;\n  }\n\n  .attendee-avatar {\n    border-radius: 50%;\n    margin-left: -2px;\n    box-shadow: 0 1px 3px rgba(28, 36, 46, 0.22);\n    --size:20px;\n    &.no-image {\n      width: 20px;\n      height: 20px;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      border: 0.5px solid #787878;\n      background: linear-gradient(145deg, #f7f8fa 0%, #e9edf2 100%);\n      color: #38424f;\n      font-size: 9px;\n      font-weight: 600;\n      letter-spacing: 0.1px;\n    }\n    &:first-child {\n      margin-left: 0;\n    }\n\n    &.organizer {\n      background: linear-gradient(145deg, #dde2ea 0%, #c9d3e0 100%);\n      color: #1f2e41;\n      box-shadow: 0 1px 4px rgba(22, 31, 44, 0.26);\n      width: 24px;\n      height: 24px;\n      --size:24px;\n    }\n\n    &.overflow {\n      background: linear-gradient(145deg, #f2f4f7 0%, #e2e7ee 100%);\n      color: #556273;\n      // font-size: 8.5px;\n      font-weight: 700;\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  .booking-card-actions {\n    display: flex;\n    align-items: center;\n    align-self: center;\n    gap: 6px;\n    margin-left: 4px;\n    color: #5f6368;\n    font-size: 20px;\n\n    .delete-icon {\n      color: #ed143d;\n    }\n\n    .chevron-icon {\n      font-size: 22px;\n      color: #737373;\n    }\n  }\n\n  .booking-bottom-divider {\n    margin: 0 auto;\n    width: calc(100% - 20px);\n    height: 1px;\n    background: #e2e2e2;\n  }\n\n  .booking-bottom-row {\n    display: flex;\n    align-items: end;\n    justify-content: end;\n    // gap: 8px;\n    min-height: 45px;\n    padding-left: 10px;\n\n\n  .booking-timer {\n    flex: 1;\n    min-width: 0;\n    margin-right: 10px;\n    margin-bottom: 5px;\n\n    &.booking-time-until-start {\n      align-self: center;\n     .timer-label {\n  font-size: 10px;\n  font-weight: 600;\n  color: #757575;\n  text-align: start;\n\n  &.urgent {\n    color: #ed143d;\n  }\n}\n\n    }\n  }\n\n  .booking-bottom-button {\n    width: 100px;\n    height: 38px;\n    margin: 0;\n    text-transform: none;\n    &.check-out-button {\n        --background: #ed143d;           // default\n        --background-hover: #d91237;     // hover (≈ -10% lightness)\n        --background-activated: #c01031; // pressed (≈ -20% lightness)\n        --background-focused: #d91237;   // focus\n        --ripple-color: rgba(255, 255, 255, 0.35);\n        text-transform: none;\n    }\n    &.with-extend-meeting {\n      // width: 158px;\n      height: 30px;\n      margin-right: -10px;\n      margin-bottom: 1px;\n    }\n    &.extend-button {\n      --background: #fefefe;\n      --background-hover: #f6f6f6;\n      --background-activated: #efefef;\n      --background-focused: #f6f6f6;\n      --ripple-color: rgba(0, 0, 0, 0.12);\n      .content {\n        color:#787878;\n      }\n      &::part(native) {\n        box-shadow: -2px 2px 20px 0px #00000026;\n      }\n    }\n    &.loading {\n      --background: #FFC409;\n      --background-hover: #FFC409;\n      --background-activated: #FFC409;\n      --background-focused: #FFC409;\n    }\n    .content {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 3px;\n      color: #fff;\n      font-size: 12px;\n      font-weight: 600;\n      white-space: nowrap;\n    }\n\n    ion-icon {\n      font-size: 20px;\n    }\n\n    .extend-icon {\n      width: 16px;\n      height: 16px;\n      object-fit: contain;\n      flex-shrink: 0;\n    }\n\n    &::part(native) {\n      border-radius: 0;\n      border-top-left-radius: 15px;\n    }\n  }\n\n  // .booking-images-toggle {\n  //   display: flex;\n  //   justify-content: flex-end;\n  //   padding-right: 8px;\n\n  //   ion-icon {\n  //     font-size: 24px;\n  //   }\n  // }\n  ion-item::part(native) {\n    --inner-padding-end: 0px;\n    --padding-start: 0;\n  }\n\n\n\n  ion-card-header {\n    padding: 10px 10px 0 0px;\n    margin-left: 10px;\n    ion-card-title {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      padding-inline-start: 10px;\n      justify-content: center;\n      ion-thumbnail {\n        margin-bottom: 5px;\n        ion-avatar {\n          margin: 0 auto;\n        }\n      }\n      ion-label {\n        font-size: 20px;\n        flex-grow: 3;\n        margin-bottom: 5px;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 1;\n        line-clamp: 1;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n      .operation-buttons-container {\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 10px;\n        font-size: 26px;\n        transform: translateY(-5px);\n      }\n      .operation-buttons-container ion-icon[name=\"arrow-redo-outline\"] {\n        font-size: 24px;\n        color: var(--ion-color-primary);\n        margin-left: 8px;\n      }\n    }\n\n    ion-card-subtitle {\n      padding-bottom: 5px;\n      display: flex;\n      font-size: 11px;\n      align-items: center;\n      margin-right: 5px;\n      .location-icon {\n        margin-right: 2.5px;\n      }\n    }\n  }\n\n  ion-card-content {\n    margin-left: 10px;\n    padding: 0px;\n    // display: flex;\n    // align-items: center;\n    .chips-container {\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n      padding-bottom: 8px;\n      padding-right: 8px;\n    }\n    .event-detail {\n      display: flex;\n      gap: 3px;\n      align-items: center;\n      font-size: 13px;\n      padding: 2px 5px;\n\n      ion-icon {\n        font-size: 20px;\n        margin-right: 5px;\n      }\n    }\n\n    ion-chip {\n      padding-inline: 10px;\n      font-size: 11px;\n\n      ion-icon {\n        margin-right: 3.5px;\n      }\n\n      &.organizer-chip {\n        img {\n          margin-right: 3.5px;\n        }\n      }\n    }\n\n\n  }\n  \n}\n}\nion-popover {\n  --max-height: 40vh;\n  --min-width: 240px;\n}\n\nion-popover.seriesPopOver::part(content) {\n  left: calc((100% - 90%) / 2);\n}\n\nion-popover.seriesPopOver {\n  --width: 90%;\n  --min-height: 0;\n}\n\nion-popover.ResponsePopOver {\n  --min-width: fit-content;\n}\n\nion-popover.info-popover::part(content) {\n  min-width: unset;\n  width: fit-content;\n}\n\nion-popover.info-popover {\n  .resource-response-tip {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    ion-icon {\n      font-size: 22px;\n      flex-shrink: 0;\n    }\n\n    ion-label {\n      margin: 0;\n    }\n  }\n}\n\nion-popover.resource-images-popover {\n  --height: unset;\n  --max-height: unset;\n  --width: 420px;\n  &::part(content) {\n    padding: 7px;\n  }\n  .image-swiper-container {\n    --swiper-pagination-color: #ed143d;\n    width: 100%;\n    overflow: hidden;\n    border-radius: 8px;\n    swiper-slide {\n      .image-container {\n        width: 100%;\n        height: 280px;\n        overflow: hidden;\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n      }\n    }\n  }\n  .resource-images-info {\n    padding-top: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    ion-label {\n      font-weight: 600;\n    }\n    ion-icon {\n      font-size: 16px;\n      color: #ed143d;\n    }\n    ion-chip {\n      cursor: default;\n    }\n  }\n}\n\nion-popover.display-name {\n  --width: 275px;\n  ion-icon {\n    font-size: 16px;\n  }\n  ion-label {\n    margin: 5px 10px;\n    .displayName,\n    .address,\n    .emailAddress {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      margin: 7px 0;\n      word-break: break-word;\n\n      div {\n        display: flex;\n      }\n    }\n    .address {\n      font-size: 12px !important;\n      // margin-left: -2px;\n      ion-icon {\n        font-size: 16px;\n      }\n    }\n    .displayName {\n      font-size: 15px;\n    }\n    .emailAddress {\n      ion-icon {\n        color: #6e6e6e;\n      }\n      small {\n        color: #6e6e6e;\n        font-size: 12px;\n        font-weight: 500;\n      }\n    }\n  }\n}\n\nion-popover.extend-meeting-popover {\n  --width: 325px;\n  --height: unset;\n  .extend-meeting-container {\n    padding: 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  .title-label {\n    text-align: center;\n    font-weight: 600;\n  }\n  .extend-meeting-options {\n    margin: 0 auto;\n    ion-chip {\n      padding: 4px 8px;\n      min-height: unset;\n    }\n  }\n  .extend-meeting-error-note {\n    text-align: center;\n    font-size: 12px;\n    color: #ed143d !important;\n  }\n}\n\n.container {\n  ion-item {\n    font-size: 12px;\n\n    ion-icon {\n      font-size: 30px;\n      margin-right: 5px;\n    }\n  }\n\n  font-size: 14px;\n  max-height: 250px !important;\n  margin: 8px 5px 8px 13px;\n  overflow-y: scroll;\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: var(--ion-color-light);\n    border-radius: 2px;\n  }\n\n  .inner-scroll {\n    scrollbar-width: thin;\n  }\n}\n.tip-container {\n  margin: 8px 13px 8px 13px;\n  font-size: 14px;\n}\n\n.user-response-container {\n  ion-icon {\n    font-size: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
